export default __webpack_public_path__ + "static/media/Features.2f7d6058.png";